import React, { useState, useEffect } from "react";
import { formatAgo } from "../../utils/miscUtils";

export function isChrome() {
  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = typeof window.opr !== "undefined";
  const isIEedge = winNav.userAgent.indexOf("Edge") > -1;
  const isIOSChrome = winNav.userAgent.match("CriOS");

  if (isIOSChrome) {
    return true;
  } else if (
    isChromium !== null &&
    typeof isChromium !== "undefined" &&
    vendorName === "Google Inc." &&
    isOpera === false &&
    isIEedge === false
  ) {
    return true;
  } else {
    return false;
  }
}

const BrowserWarning = ({ message, warningDate }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [formattedDate, setFormattedDate] = useState("");
  useEffect(() => {
    // Function to update the formatted date
    const updateFormattedDate = () => {
      if (warningDate) {
        setFormattedDate(formatAgo(warningDate));
      }
    };

    // Initial update
    updateFormattedDate();

    // Set up interval to update every minute
    const intervalId = setInterval(updateFormattedDate, 60000);

    // Clean up function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [warningDate]);

  const dismissWarning = () => {
    setIsVisible(false);
    // Store the dismissal in session storage
    sessionStorage.setItem("browserWarningDismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-black p-2 text-center z-[999999] flex justify-between items-center">
      <div className="flex-grow">
        {message}
        {warningDate && (
          <span className="flex-shrink text-gray-700 text-xs ml-4">
            {formattedDate}
          </span>
        )}
      </div>
      <button
        onClick={dismissWarning}
        className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-1 px-2 rounded ml-2"
      >
        ✕
      </button>
    </div>
  );
};

export default BrowserWarning;
